/**
 * Get a cookie by name.
 *
 * @param {string} name
 * @returns {?string}
 */
export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return decodeURIComponent(parts.pop().split(';').shift());
    }
    return null;
}

/**
 * Set a cookie.
 */
export function setCookie(key, value = '', expires = null, path = '/', secure = false, domain = null) {
    const values = [encodeURIComponent(value)];

    if (expires) {
        const date = new window.Date(window.Date.now() + (expires * 1000));
        values.push(`expires=${date.toUTCString()}`);
    }

    if (path) values.push(`path=${path}`);

    if (secure) values.push('secure=true');

    if (domain !== null) values.push(`domain=${domain}`);

    document.cookie = `${key}=${values.join(';')}`;
}

/**
 * Erase an existing cookie
 */
export function eraseCookie(key, domain = null) {
    if (!getCookie(key)) return;
    setCookie(key, '', 'Thu, 01 Jan 1970 00:00:00 UTC', '/', false, domain);
}

/**
 * Get domain for cross application cookies
 */
export function getCookieDomain(prefix = '.') {
    const host = window.location.hostname.split('.');

    if (host.length > 3) { // Is needed for staging only
        host.splice(0, 2);
    }

    return host.length === 1 ? window.location.hostname : (prefix + host.join('.'));
}
